
import Field from "./Field";
import { useTranslation } from "react-i18next";
import JsBarcode from "jsbarcode";
import React, { useEffect, useRef } from "react";


const Barcode = ({ value }) => {
  const svgRef = useRef(null);

  useEffect(() => {
    if (value && svgRef.current) {
      JsBarcode(svgRef.current, value, {
        format: "CODE128",
        width: 1.15,
        height: 48,
        displayValue: false,
        margin: 0,
      });
    }
  }, [value]);

  return <svg ref={svgRef} />;
};

const DanfeHeader = ({ data, folha }) => {

    const { t } = useTranslation();

  return (
  <>
    <div className="danfe-header">
      <div className="danfe-header-issuer">
        <div className="header-mini-title">{t("danfe.issueridentification").toUpperCase()}</div>
        <div className="issuer-name">{data.emitente.nome}</div>
        <div className="issuer-line">{data.emitente.endereco}</div>
        <div className="issuer-line">{data.emitente.municipioUf}</div>
        <div className="issuer-line">{data.emitente.fone}</div>
      </div>

      <div className="danfe-header-center">
        <div className="danfe-title">{t("danfe.danfe").toUpperCase()}</div>
        <div className="danfe-subtitle">{t("danfe.auxiliaryInvoice")}</div>
        <div className="danfe-subtitle">{t("danfe.electronicTax")}</div>

        <div className="entrada-saida-wrap">
          <div>{t("danfe.entry").toUpperCase()}</div>
          <div>{t("danfe.exit").toUpperCase()}</div>
          <div className="entrada-saida-box">{data.tipoEntradaSaida}</div>
        </div>

        <div className="numero-box">{t("danfe.number")} {data.numero}</div>
        <div className="serie-box">{t("danfe.serie")} {data.serie}</div>
        <div className="folha-box">{t("danfe.sheet")} {folha}</div>
      </div>

      <div className="danfe-header-barcode">
        <Barcode value={(data.chaveAcesso || "").replace(/\D/g, "")} />
        <div className="barcode-key-label">{t("danfe.accessKey").toUpperCase()}</div>
        <div className="barcode-key-value">{data.chaveAcesso}</div>
        <div className="barcode-consulta">
          {t("danfe.verificationAuthenticity")}
        </div>
        <div className="barcode-consulta">
          {t("danfe.sefazWebsite")}
        </div>
      </div>
    </div>

    <div className="danfe-row">
      <Field
        label={t("danfe.natureOperation").toUpperCase()}
        value={data.naturezaOperacao}
        className="w-59 bold-value"
      />
      <Field
        label={t("danfe.authorizationProtocol").toUpperCase()}
        value={data.protocolo}
        className="w-43 bold-value"
      />
    </div>

    <div className="danfe-row">
      <Field
        label={t("danfe.ie").toUpperCase()}
        value={data.emitente.ie}
        className="w-25 bold-value"
      />
      <Field
        label={t("danfe.im").toUpperCase()}
        value={data.emitente.im}
        className="w-26"
      />      
      <Field
        label={t("danfe.iest").toUpperCase()}
        value={data.emitente.ieSubst}
        className="w-26"
      />
      <Field
        label={t("danfe.cnpj").toUpperCase()}
        value={data.emitente.cnpj}
        className="w-26 bold-value"
      />
    </div>
  </>
  )
}

export default DanfeHeader;